// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31lSI","signatureBlock":"Footer_signatureBlock__3t3VH","signature":"Footer_signature__3HiwX"};